class VwRoltanimDTO {
    id?: number = 0;
    roladi?: string = "";
    aktif?: string = "E";
    baslangicTar?: string = null;
    bitisTar?: string = null;
    adi?: string = "";
    rolTipi?: number = null;
    ekleyenKullanici?: number = null;
    eklemeTarihi?: string = null;
    guncelleyenKullanici?: number = null;
    guncellemeTarihi?: string = null;
    aktifBool?: boolean = true;
}
export default VwRoltanimDTO;